import { ApiErrorPage } from '@britishcouncil/react-solas-ors3';

export const Error401 = () => {
  return (
    <ApiErrorPage errorMessage="You are not authorized to this page. Please log in" />
  );
};
